// removed by extract-text-webpack-plugin
module.exports = {"list__item":"List-hashed__list__item__cgxF2","list__itemContent":"List-hashed__list__itemContent__Bstq6","list__dataWrap":"List-hashed__list__dataWrap__1WQh5","list__data":"List-hashed__list__data__2znBs","list__dataLabel":"List-hashed__list__dataLabel__3yQnc"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/common/directives/schedules/scheduleTypes/readonly/Mobile/List-hashed.scss
// module id = 1241
// module chunks = 0